module.exports = __webpack_public_path__ + "img/brickStream.316aed8b.png";